import { Translate } from "../types"

const translate_DE: Translate =  {
    Language: {
        it: "Italienisch",
        en: "Englisch",
        de: "Deutsch"
    },

    Municipal: {
        bolzano: "Bozen",
        merano: "Meran",
        brunico: "Bruneck",
        bressanone: "Brixen"
    },

    ButtonText: {
        start: 'START',
        next: 'NEXT',
        confirm: 'BESTÄTIGEN',
        customise: 'ANPASSEN',
        cancel: 'CANCEL',
        download: 'HERUNTERLADEN',
        try_again: 'Versuch es nochmal',
        read_more: 'MEHR LESEN'
    },

    Text: {
        select_cat_character_title: 'Wählen Sie die Katze, mit der Sie sich am meisten identifizieren',
        found: 'FESTSTELLUNGEN',
        and: 'und',
        drag_here_answer: 'Ziehen Sie die Antwort hierher',
        loading: 'Wird geladen...',
        retry: 'Erneut versuchen',
        reset: 'Zurücksetzen',
        unableToLoadImage: "Bild kann nicht geladen werden",
        checkConnectionRetry: "Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut",
        imageLoadError: "Fehler beim Laden des Bildes.",
    },

    ErrorText: {
        invalid_qrcode: 'Falscher QRCODE'
    },

    PuzzleText:{
        station4: {
            bolzano: 'Giardino delle',
            merano: 'Park',
            bressanone: 'Giardini',
            brunico: 'Passeggiata'
        },

        station4_sport: { //translate to German
            bolzano: {title: '263213715', text: 'Arrampicata, Karate, Calcio, Ciclismo, Golf, Sci, Pallavolo, Nuoto, Tennis'},
            merano: {title: '65157', text: 'Tennis, Calcio, Sci, Ciclismo, Arrampicata'},
            bressanone: {title: '3216', text: 'Karate, Calcio, Pallacanestro, Arrampicata'} ,
            brunico: {title: '55944', text: 'Karate, Calcio, Pallacanestro, Ciclismo, Nuoto'} 
        },

        station5_puzzle2: 'Diakone orten'
    },

    CharacterDogType: {
        dog_geek: 'Brainy',
        dog_music: 'Folky',
        dog_sport: 'Stretchy',
        dog_fashion: 'Sparky'
    }
}

export default translate_DE;